import React, { useState, forwardRef } from 'react'
import Slider from 'react-slick'
import { IconRegularChevronLeft, IconRegularChevronRight } from '@notino/react-styleguide'

// components
import OverlayLoading from '../../atoms/OverlayLoading/OverlayLoading'

// types
import { ReservationsSliderProps } from './types'

// styles
import * as SC from './ReservationsSliderStyles'

const DEFAULT_INITIAL_SLIDE_INDEX = 0
const SLIDES_TO_SHOW = 2

const ReservationsSlider = forwardRef<HTMLDivElement, ReservationsSliderProps>((props, mobileSliderRef) => {
	const { slides, mobileBreakpoint = 'lg', initialSlide, afterChange, isLazyLoadingData = false } = props

	const initialSlideIndex = initialSlide ?? DEFAULT_INITIAL_SLIDE_INDEX
	const [currentIndex, setCurrentIndex] = useState(initialSlideIndex)

	const isFirstItemActive = currentIndex === 0
	const isLastItemActive = currentIndex + SLIDES_TO_SHOW === slides.length

	const slidesToRender = slides.map((slide, index, array) => {
		return (
			<SC.SlideWrapper
				key={index}
				$breakpoint={mobileBreakpoint}
				$isFirstItem={index === 0}
				$isLastItem={array.length === index + 1}
				$slidesCount={array.length}
			>
				{slide}
			</SC.SlideWrapper>
		)
	})

	const handleBeforeChange = (_currentSlide: number, nextSlide: number) => {
		setCurrentIndex(nextSlide)
	}

	return (
		<SC.ReservationsSliderContainer>
			<OverlayLoading isLoading={isLazyLoadingData} announceStatus>
				<SC.MobileSlider ref={mobileSliderRef} $breakpoint={mobileBreakpoint} $isLazyLoadingData={isLazyLoadingData}>
					{slidesToRender}
				</SC.MobileSlider>
				<SC.DesktopSlider
					$breakpoint={mobileBreakpoint}
					$showPrevArrow={!isFirstItemActive && slides.length > SLIDES_TO_SHOW}
					$showNextArrow={!isLastItemActive && slides.length > SLIDES_TO_SHOW}
					$isLazyLoadingData={isLazyLoadingData}
				>
					<Slider
						infinite={false}
						accessibility
						speed={500}
						slidesToShow={SLIDES_TO_SHOW}
						slidesToScroll={SLIDES_TO_SHOW}
						nextArrow={<IconRegularChevronRight color={'icon.primary'} />}
						prevArrow={<IconRegularChevronLeft color={'icon.primary'} />}
						autoplay={false}
						beforeChange={handleBeforeChange}
						afterChange={afterChange}
						arrows
						draggable={false}
						initialSlide={initialSlideIndex}
					>
						{slidesToRender}
					</Slider>
				</SC.DesktopSlider>
			</OverlayLoading>
		</SC.ReservationsSliderContainer>
	)
})

export default ReservationsSlider
